import { render } from "./TeachData.vue?vue&type=template&id=0be6c20a&scoped=true"
import script from "./TeachData.vue?vue&type=script&lang=js"
export * from "./TeachData.vue?vue&type=script&lang=js"

import "./TeachData.vue?vue&type=style&index=0&id=0be6c20a&scoped=true&lang=scss"

import exportComponent from "/root/.jenkins/workspace/外网-四川职业技术学院门户-前台页面/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0be6c20a"]])

export default __exports__